module.exports = __webpack_public_path__ + "img/vol02_heading.6b9ede1b.png";